import { observable, makeObservable } from 'mobx';
import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';

export interface IPointOfSaleProductPriceOverrideEntityAttributes extends IModelAttributes {
	price: number;
	pointOfSaleProductId: string;
	pointOfSaleProduct?: Models.PointOfSaleProductEntity | Models.IPointOfSaleProductEntityAttributes;
	userDisplayNameId: string;
	// The server projects userDisplayName as a flat displayName string on read; widened here so the entity
	// can hydrate a stub reference from either the standard nested object or the legacy string shape.
	userDisplayName?: Models.UserDisplayNameEntity | Models.IUserDisplayNameEntityAttributes | string;
}

@entity('PointOfSaleProductPriceOverrideEntity', 'Point Of Sale Product Price Override')
export default class PointOfSaleProductPriceOverrideEntity
	extends Model
	implements IPointOfSaleProductPriceOverrideEntityAttributes
{
	public static excludeFromCreate: string[] = [];
	public static excludeFromUpdate: string[] = [];

	@observable
	@attribute<PointOfSaleProductPriceOverrideEntity, number>()
	public price: number;

	@observable
	@attribute()
	public pointOfSaleProductId: string;

	@observable
	@attribute({ isReference: true, manyReference: false })
	public pointOfSaleProduct?: Models.PointOfSaleProductEntity;

	@observable
	@attribute()
	public userDisplayNameId: string;

	@observable
	@attribute({ isReference: true, manyReference: false })
	public userDisplayName?: Models.UserDisplayNameEntity;

	constructor(attributes?: Partial<IPointOfSaleProductPriceOverrideEntityAttributes>) {
		super(attributes);
		makeObservable(this);
		this.assignAttributes(attributes);
	}

	public assignAttributes(attributes?: Partial<IPointOfSaleProductPriceOverrideEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (attributes.price !== undefined) {
				this.price = attributes.price;
			}
			if (attributes.pointOfSaleProductId !== undefined) {
				this.pointOfSaleProductId = attributes.pointOfSaleProductId;
			}
			if (attributes.pointOfSaleProduct !== undefined) {
				if (attributes.pointOfSaleProduct === null) {
					this.pointOfSaleProduct = undefined;
				} else if (attributes.pointOfSaleProduct instanceof Models.PointOfSaleProductEntity) {
					this.pointOfSaleProduct = attributes.pointOfSaleProduct;
					this.pointOfSaleProductId = attributes.pointOfSaleProduct.id;
				} else {
					this.pointOfSaleProduct = new Models.PointOfSaleProductEntity(attributes.pointOfSaleProduct);
					this.pointOfSaleProductId = this.pointOfSaleProduct.id;
				}
			}
			if (attributes.userDisplayNameId !== undefined) {
				this.userDisplayNameId = attributes.userDisplayNameId;
			}
			if (attributes.userDisplayName !== undefined) {
				if (attributes.userDisplayName === null) {
					this.userDisplayName = undefined;
				} else if (attributes.userDisplayName instanceof Models.UserDisplayNameEntity) {
					this.userDisplayName = attributes.userDisplayName;
					this.userDisplayNameId = attributes.userDisplayName.id;
				} else if (typeof attributes.userDisplayName === 'string') {
					this.userDisplayName = new Models.UserDisplayNameEntity({
						id: this.userDisplayNameId,
						displayName: attributes.userDisplayName,
					});
				} else {
					this.userDisplayName = new Models.UserDisplayNameEntity(attributes.userDisplayName);
					this.userDisplayNameId = this.userDisplayName.id;
				}
			}
		}
	}
}
